import { useState, useEffect, createElement, Fragment, useLayoutEffect, } from 'react';
import { Button, ButtonVariant } from '@sas/nova-commons/components/Button';
import { embeddedBundle } from './locale/embeddedI18N';
import { authorize, getConnection, _serverHackOrAuthorized } from './authorization';
import { getAuthUrl } from './authorizeImpl';
import { Loading } from './Loading';
import { useDesignTokens } from '@sas/nova-commons/theme';
const timeoutMS = 250;
function popupWindow(server, title) {
    const state = checkPopupState();
    if (state === 'open') {
        if (popupServer === server) {
            globalPopup === null || globalPopup === void 0 ? void 0 : globalPopup.focus();
            return;
        }
        closePopup();
    }
    const top = window.outerHeight / 2 + window.screenY - 600 / 2;
    const left = window.outerWidth / 2 + window.screenX - 700 / 2;
    const popup = window.open(getAuthUrl(server), title, `width=700,height=600,top=${top},left=${left}`);
    if (popup) {
        startPopupIntervalCheck(server, popup);
    }
    return popup;
}
let intervalCheckId;
let popupServer;
let globalPopup = null;
let messageCb;
function closePopup() {
    if (globalPopup) {
        globalPopup.close();
        globalPopup = null;
    }
    if (messageCb) {
        window.removeEventListener('message', messageCb);
        messageCb = undefined;
    }
    if (intervalCheckId !== undefined) {
        clearInterval(intervalCheckId);
        intervalCheckId = undefined;
        popupServer = undefined;
    }
}
function checkPopupState() {
    if (!globalPopup || globalPopup.closed) {
        closePopup();
        return 'closed';
    }
    if (!popupServer) {
        if (globalPopup && !globalPopup.closed) {
            closePopup();
        }
        return 'closed';
    }
    if (_serverHackOrAuthorized(popupServer)) {
        closePopup();
        return 'closed';
    }
    globalPopup.postMessage('register', '*');
    return 'open';
}
function startPopupIntervalCheck(server, popup) {
    checkPopupState();
    if (intervalCheckId) {
        return;
    }
    popupServer = server;
    globalPopup = popup;
    messageCb = (event) => {
        if (server.indexOf(event.origin) !== -1 && event.data && event.data.logonStatus) {
            authorize(server);
        }
    };
    window.addEventListener('message', messageCb);
    // @ts-ignore node type map leakage
    intervalCheckId = setInterval(() => {
        checkPopupState();
    }, timeoutMS);
}
export const Logon = (props) => {
    var _a, _b;
    const { url, authenticationType = 'credentials' } = props;
    const [auth, setAuth] = useState(() => getConnection(url, authenticationType).currentItem);
    useEffect(() => {
        return getConnection(url, authenticationType).subscribe((state) => setAuth(state));
    }, [url, authenticationType]);
    // checkPopupState on unmount
    useEffect(() => () => {
        checkPopupState();
    }, []);
    const dt = useDesignTokens();
    const error = auth.error;
    const onError = props.onError;
    useLayoutEffect(() => {
        if (error) {
            onError === null || onError === void 0 ? void 0 : onError(error);
        }
    }, [error, onError]);
    if (auth.status === 'authorized' && props.children) {
        return createElement(Fragment, null, props.children);
    }
    else if (auth.status !== 'credentials-invalid') {
        return props.loadingFallback ? props.loadingFallback() : createElement(Loading, null);
    }
    else {
        return (createElement("div", { style: Object.assign({ display: 'flex', flexShrink: 1, flexDirection: 'column', height: '100%', justifyContent: 'center', alignItems: 'center', backgroundColor: dt.enableNovaTokens
                    ? dt.backgroundsNova.panes.bg
                    : dt.backgrounds.panes.bg }, props.style) },
            createElement("div", { style: { color: ((_a = props.style) === null || _a === void 0 ? void 0 : _a.color) ? (_b = props.style) === null || _b === void 0 ? void 0 : _b.color : getTextColor(dt) } }, embeddedBundle['logon.message.msg']()),
            createElement(Button, { text: embeddedBundle['logon.button.msg'](), variant: ButtonVariant.Primary, onPress: () => {
                    popupWindow(props.url, 'SAS Logon');
                }, tokens: props.buttonTokens })));
    }
};
// Forked from BusyStateIndicator
function getTextColor(dt) {
    switch (dt.themeVariant) {
        case 'dark':
        case 'high-contrast':
            return dt.c.white;
        default:
            return dt.c.n_3;
    }
}
//# sourceMappingURL=Logon.js.map